import { Form } from "react-bootstrap";

const NewDynamicText = ({
  value = "",
  valueKey = "",
  isUpdated = false,
  isRequired = false,
  onChange,
  inputWidth = 85,
}) => {
  const requiredCheck = isRequired && !value;

  return (
    <Form.Control
      type="text"
      value={value}
      style={{ width: `${inputWidth}%` }}
      className={`mt-1 text-input ${
        isUpdated ? "updated" : requiredCheck ? "required" : ""
      }`}
      onChange={(e) =>
        onChange({
          key: valueKey,
          value: e.target.value,
        })
      }
    />
  );
};

export default NewDynamicText;
